import { SalonAnalysis } from './salon-analysis'

/**
 * Play Salon Analysis - wrapper component using shared SalonAnalysis
 */
const PlaySalonAnalysis = () => {
  return <SalonAnalysis operator="play" />
}

export default PlaySalonAnalysis
